import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import {
  RootRoute,
  LoginRoute,
  NetworkErrorRoute,
  ErrorPage403Route,
  ErrorPageRoute
} from '@/router/base'
import { createRouterGuards } from './router-guards'
import { useRouteStoreWithOut } from '@/stores/modules/route'

// // 菜单
import routeModuleList from './modules'

// // 普通路由
export const constantRouter = [
  RootRoute,
  LoginRoute,
  NetworkErrorRoute,
  // ErrorPage403Route,
  ErrorPageRoute
]

const { VITE_PUBLIC_PATH } = import.meta.env

const history = createWebHistory(VITE_PUBLIC_PATH)

const routeStore = useRouteStoreWithOut()
routeStore.setMenus(routeModuleList)
routeStore.setRouters(constantRouter.concat(routeModuleList))

const router = createRouter({
  // history: createWebHashHistory(''),
  history,
  routes: constantRouter.concat(...routeModuleList),
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 })
})

router.beforeEach(async (to, from, next) => {
  next()
  // 友盟统计 sendPV
  window.aplus_queue.push({
    action: 'aplus.sendPV',
    arguments: [{ is_auto: false }] // 此处上报的数据暂时在后台没有展示
  })
})

console.log(constantRouter.concat(...routeModuleList))
export function setupRouter(app) {
  app.use(router)
  // 创建路由守卫
  createRouterGuards(router)
}

export default router
